<template>
  <div class="add-listing-page">
    <h2 class="text-h5 mt-6 mb-6 font-weight-regular text-left ml-2">
      {{ $t("Cmsg12") }}
    </h2>
    <v-card elevation="0" class="ma-1 white">
      <v-card>
        <v-form ref="form">
          <v-card-text class="pl-4 pr-4">
            <v-row>
              <v-col cols="12" md="7" v-if="data.steps == 4">
                <div class="body-2 pb-5">{{ $t("Cmsg13") }}</div>
                <l-map
                  :zoom="10"
                  :center="[data.position[1], data.position[0]]"
                  style="width: 100%; height: 600px"
                >
                  <l-tile-layer :url="url" :attribution="attribution" />
                  <l-marker
                    draggable
                    :lat-lng="[data.position[1], data.position[0]]"
                    @update:latLng="updateCoordinates"
                  >
                  </l-marker>
                  <v-autocomplete
                    no-filter
                    class="map-search"
                    hide-details="auto"
                    :loading="loading"
                    :items="entries"
                    :search-input.sync="search"
                    item-text="locale_names"
                    flat
                    dense
                    disable-lookup
                    outlined
                    v-bind:label="$t('1Loc')"
                    @change="onChange"
                    return-object
                    clearable
                  ></v-autocomplete>
                </l-map>
              </v-col>
              <v-col cols="12" md="5">
                <h2 class="text-h6 font-weight-regular text-left pl-md-5 mt-12">
                  {{ $t("AddNearByAttractions") }}
                </h2>
                <div class="pl-md-5">
                  <v-row>
                    <v-col cols="12" md="7">
                      <v-text-field
                        v-model="near_attraction.place"
                        type="text"
                        v-bind:label="$t('Place')"
                        outlined
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="8" md="5">
                      <v-text-field
                        v-model="near_attraction.distance"
                        type="number"
                        v-bind:label="$t('Distance')"
                        suffix="Miles"
                        hide-details="auto"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        large
                        class="text-right white--text"
                        color="light-blue"
                        @click="addAttraction"
                        :disabled="
                          !near_attraction.place || !near_attraction.distance
                        "
                      >
                        <v-icon small class="mr-2">mdi-plus</v-icon
                        >{{ $t("Add") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-chip
                    v-for="(n, index) in data.near_attractions"
                    :key="index"
                    class="ma-2"
                    close
                    color="grey"
                    label
                    outlined
                    @click:close="() => removeAttraction(index)"
                  >
                    {{ n.place }}: {{ n.distance }} Miles
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-card>
    <div class="text-right mt-10">
      <v-btn
        outlined
        color="grey"
        large
        class="mr-2"
        @click="$emit('goBack')"
        >{{ $t("Back") }}</v-btn
      >
      <v-btn large color="light-blue white--text" rounded @click="next">
        <span class="mr-2">{{ $t("Continue") }}</span>
        <v-icon size="small">mdi-arrow-right-thick</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import ListingService from "@/services/ListingService";

export default {
  props: ["data"],
  name: "Step4Component",
  data() {
    return {
      near_attraction: {},
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      location: null,
      items: [],
      search: null,
      loading: false
    };
  },
  watch: {
    search(val) {
      val && val.length > 3 && val !== this.select && this.citySelections(val);
    }
  },
  computed: {
    entries() {
      return this.items.map(e => {
        const locale_names = e.place_name;
        const lat = e.center[1];
        const lng = e.center[0];
        return Object.assign({}, { locale_names, lat, lng });
      });
    }
  },
  methods: {
    onChange(e) {
      if (e) {
        this.data.position = [e.lng, e.lat];
      }
    },
    citySelections(val) {
      if (val) {
        ListingService.citySearch({ query: val })
          .then(result => {
            this.items = result.data.features;
          })
          .catch(err => {
            this.error = err.response.data.errors;
          });
      }
    },
    updateCoordinates(location) {
      this.data.position = [location.lng, location.lat];
    },
    removeAttraction(index) {
      this.data.near_attractions.splice(index, 1);
    },
    addAttraction() {
      this.data.near_attractions.push(this.near_attraction);
      this.near_attraction = {};
    },
    async next() {
      window.scrollTo(0, 0);
      this.data.steps = 5;
    }
  }
};
</script>

<style>
.v-input.map-search {
  position: absolute;
  z-index: 1000;
  width: 80%;
  margin: 10px 8%;
  background: #fff;
  padding: 2%;
}
</style>
